<template>
	<div class="visaserch">
		<back-to></back-to>
		<section class="visaserch-search">
			<span class="packageSearch_con-inps">
				<img src="../../assets/search.png" alt="">
				<input type="text" class="packageSearch_con__input" v-model="keyWord" placeholder="景点、关键词、目的地"
					@keyup.13="onSearch" />
			</span>
		</section>
		<!-- 列表 -->
		<img v-if="loadShow" src="../../assets/loading.gif" alt="" class="loading">
		<van-list v-else class="visaList" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
			:immediate-check="false">
			<div class="visaList-item" v-for="(item,index) in data_product_array" :key="index">
				<span class="visaList-item_left">
					<img :src="item.ImagePath" alt="">
					<label for="">
						<p>{{item.Destination}}</p>
					</label>
				</span>
				<span class="visaList-item_right">
					<h2>{{item.Title}}</h2>
					<label for="" class="visaList-item_rightc">
						<span class="visaList-item_rightcl">
							<font>￥</font>
							{{item.Price}}
							<font style="color: #333;">起</font>
						</span>
						<span class="visaList-item_rightcr">{{item.Dynamic}}</span>
					</label>
					<p v-for="(items,key) in item.Marks" :key="key"> {{items}}</p>
				</span>
			</div>
		</van-list>
	</div>
</template>

<script>
	import BackTo from '@/components/BackTo.vue'
	export default {
		name: 'visaserch',
		components: {
			BackTo
		},
		data() {
			return {
				keyWord: "",
				loading: false,
				finished: false,
				page: 1,
				data_product_array: [],
				loadShow: true
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.page = this.page + 1
					this.getList()
				}, 500);
			},
			onSearch() {
				this.loading = false
				this.finished = false
				this.page = 1
				this.getList(true)
			},
			getList(e) {
				var mydata = {
					'Keyword': this.keyWord,
					'Type': 4,
					'pageIndex': this.page
				}
				this.$post(
					this.$apiWebsiteSweet + '/Search/GetSearchResultListByType', mydata
				).then(res => {
					this.loadShow = false
					console.log(res)
					if (e) {
						this.data_product_array = res.ProductList.VisaList
					} else {
						this.data_product_array = this.data_product_array.concat(res.ProductList.VisaList)
					}
					if (res.ProductList.VisaList.length < 10) {
						this.finished = true;
					}
				})
			}
		}

	}
</script>

<style scoped>
	.visaserch .loading {
		width: 300px;
		height: 300px;
		position: fixed;
		top: 30%;
		left: 50%;
		transform: translateX(-50%);
	}

	.visaserch-search {
		width: 100%;
		padding: 0 30px;
		box-sizing: border-box;
		margin-top: 14px;
	}

	.visaserch .packageSearch_con-inps {
		width: 100%;
		background-color: #f7f7f7;
		height: 66px;
		border-radius: 10px;
		width: 690px;
		font-size: 26px;
		color: #b2b2b2;
		display: flex;
		align-items: center;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.visaserch .packageSearch_con-inps img {
		width: 40px;
	}

	.visaserch .packageSearch_con-inps input {
		width: 100%;
		background-color: #f7f7f7;
		border: 0;
		padding-left: 14px;
		box-sizing: border-box;
	}

	.visaList {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.visaList-item {
		width: 100%;
		border-bottom: 1px solid #e5e5e5;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 0;
	}

	.visaList-item_left {
		width: 33%;
		position: relative;
	}

	.visaList-item_left img {
		height: 170px;
		width: 100%;
		border-radius: 15px;
	}

	.visaList-item_left label {
		border-radius: 15px;
		height: 170px;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.visaList-item_left label p {
		height: 44px;
		line-height: 44px;
		width: 100%;
		text-align: center;
		background-color: rgba(0, 0, 0, .7);
		color: #fff;
		font-size: 24px;
		border-bottom-right-radius: 15px;
		border-bottom-left-radius: 15px;
		margin-top: auto;
	}

	.visaList-item_right {
		width: 65%;
		float: right;
		overflow: hidden;
		height: 170px;
		display: flex;
		flex-direction: column;
	}

	.visaList-item_right h2 {
		font-size: 27px;
		width: 100%;
		color: #333;
		font-weight: bold;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.visaList-item_rightc {
		display: flex;
		align-items: center;
		color: #ff6d00;
		font-size: 28px;
		padding-top: 14px;
	}

	.visaList-item_rightcr {
		width: 556px;
		line-height: 29px;
		float: left;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.visaList-item_rightcl {
		display: flex;
		align-items: baseline;
		margin-right: 30px;
	}

	.visaList-item_rightcl font {
		font-size: 20px;
	}

	.visaList-item_right p {
		font-size: 24px;
		color: #333;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 45px;
		height: 45px;
		margin-top: auto;
	}
</style>
